
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.25 15a.75.75 0 010-1.5h3a.75.75 0 010 1.5h-3z"}}),_c('path',{attrs:{"d":"M2.25 18A2.252 2.252 0 010 15.75v-7.5A2.252 2.252 0 012.25 6h19.5A2.252 2.252 0 0124 8.25v7.5A2.252 2.252 0 0121.75 18H2.25zm0-10.5a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h19.5a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75H2.25z"}}),_c('path',{attrs:{"d":"M7.5 15a.743.743 0 01-.53-.22l-1.345-1.345L4.28 14.78c-.141.142-.33.22-.53.22s-.389-.078-.53-.22a.752.752 0 010-1.061l1.345-1.345L3.22 11.03c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53a.743.743 0 01.53-.22c.2 0 .389.078.53.22l1.345 1.345L6.97 9.97a.743.743 0 01.53-.22c.2 0 .389.078.53.22.142.141.22.33.22.53s-.078.389-.22.53l-1.345 1.345L8.03 13.72a.752.752 0 010 1.061.746.746 0 01-.53.219zM14.25 15a.743.743 0 01-.53-.22l-1.345-1.345-1.345 1.345c-.141.142-.33.22-.53.22s-.389-.078-.53-.22a.752.752 0 010-1.061l1.345-1.345L9.97 11.03c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53a.743.743 0 01.53-.22c.2 0 .389.078.53.22l1.345 1.345L13.72 9.97a.744.744 0 01.53-.22c.2 0 .389.078.53.22.142.141.22.33.22.53s-.078.389-.22.53l-1.345 1.345 1.345 1.345a.752.752 0 010 1.061.746.746 0 01-.53.219z"}})])
          )
        }
      }
    